import { Optional } from "common/utils/types";

import Alert from "client/common/components/content/Alert";

import { SubscriptionPaymentMethod } from "../types";
import { useSubscriptionPaymentUpdateDrawer } from "../stackables";
import { getSubscriptionPaymentIssueContent } from "../utils";

type SubscriptionPaymentAlertProps = {
  subscription: {
    id: number;
    payment_method: Optional<SubscriptionPaymentMethod>;
  };
};

const SubscriptionPaymentAlert = ({ subscription }: SubscriptionPaymentAlertProps) => {
  const { open: openPaymentUpdate } = useSubscriptionPaymentUpdateDrawer();
  const { drawerMessage, actionLabel } = getSubscriptionPaymentIssueContent(
    subscription.payment_method,
  );

  // Stacked over the form it is blocking rather than routed to, so closing it returns the client
  // to the edit they came for.
  const onClick = () => {
    openPaymentUpdate({ id: subscription.id });
  };

  return (
    <Alert
      variant="danger"
      shouldScrollOnMount={true}
      actions={[{ label: actionLabel, onClick, hasRightIcon: true }]}
    >
      {drawerMessage}
    </Alert>
  );
};

export default SubscriptionPaymentAlert;
